import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface LookupItem {
    lookupCode: string;
    lookupValue: string;
}

export interface GroupedLookups {
    [lookupType: string]: LookupItem[];
}

@Injectable({
    providedIn: 'root'
})
export class LookUpService {

    constructor(private http: HttpClient) { }

    // GET request
    getLookUps(): Observable<GroupedLookups> {
        return this.http.get<GroupedLookups>('/lookups/v1/get-all-lookups');
    }

}
